import * as React from 'react';
import { useLeapState } from '../../hooks/useLeapState';
import { useLeapData } from '../../hooks/useLeapData';

import Grid from '../../components/controls/grid/Grid';
import Section from '../../components/controls/grid/Section';
import Row from '../../components/controls/grid/Row';

import DateRange from '../../components/controls/DateRange';
import SearchBox from '../../components/controls/SearchBox';
import Separator from '../../components/controls/customization/Separator';

type Props = { state: any, controller: any, parentController: string }

export default (props: Props) => {
    const page = useLeapState(props.controller, false)

    const discount = useLeapData("discount", "scontistiche", page, "discounts")
    const branchID = useLeapData("branchID", "branca", page, "branches")
    const healthservice = useLeapData("healthservice", "prestazione", page, "healthservices")
    const start_date = useLeapData("start_date", "data inizio validità", page)
    const end_date = useLeapData("end_date", "data fine validità", page)

    return (
        <>
            <Grid>
                <Section>
                    <Row>
                        <SearchBox {...discount} className="ms-sm12" required parentController={props.parentController} />
                    </Row>
                    <Row>
                        <SearchBox {...branchID} className="ms-sm12" parentController={props.parentController} />
                    </Row>
                    <Row>
                        <SearchBox {...healthservice} className="ms-sm12" required parentController={props.parentController} />
                    </Row>
                    <Row>
                        <DateRange dateMin={{ ...start_date, className: "ms-sm5", required: true }} separator={{ className: "ms-sm2" }} dateMax={{ ...end_date, className: "ms-sm5" }} />
                    </Row>
                </Section>
            </Grid>
        </>
    );
}
